import axios from 'axios'
import { now } from '../../../utils/utcTime'
import {
  SET_PHONE_CALL_DETAILS,
  SET_DATA_FOR_RECENT_CALLS_TABLE,
  SAVE_DATA_FOR_ACTIVITY,
  SET_TIMELINE_DATA,
  SET_ACTIVITY_ID,
  TIMELINE_DATA_LOADING,
} from './types'
import { notificationDanger, notificationSuccess } from '../../../utils/customToastify'
import { getHistoryData } from '../../Contacts/redux/ContactActions'
import { closeModal } from '../../../common/GlobalModal/redux/GlobalModalActions'
import { RingCentralClient } from '../../../lib/ringcentral/ringCentral'
import { updateAuthData } from '../../Users/redux/userActions'

const setLoading = (isLoading) => (dispatch) => {
  dispatch({
    type: TIMELINE_DATA_LOADING,
    payload: isLoading,
  })
}

export const setPhoneCallDetails = (customerId, celler_id) => async (dispatch) => {
  dispatch({
    type: SET_PHONE_CALL_DETAILS,
    payload: { time: now(), customerId, celler_id },
  })
}

// eslint-disable-next-line no-unused-vars
export const sendEmailAndActivity = (data, attachments) => async (_dispatch) => {
  try {
    const formData = new FormData()
    formData.append('data', JSON.stringify({ ...data }))

    if (attachments && attachments.length) {
      attachments.forEach((attachment) => {
        formData.append('attachments', attachment)
      })
    }

    const response = await axios.post(`/activity`, formData, { params: { sendEmail: true } })
    return response.data
  } catch (error) {
    throw new Error(error)
  }
}

// eslint-disable-next-line no-unused-vars
export const sendClickToCall = (data, dataForActivity, attachments, callback) => async (_dispatch) => {
  const formData = new FormData()

  formData.append('data', JSON.stringify({ ...data }))

  formData.append('dataForActivity', JSON.stringify({ ...dataForActivity, creationDate: now() }))

  if (attachments && attachments.length) {
    attachments.forEach((attachment) => {
      formData.append('attachments', attachment)
    })
  }

  const response = await axios.post('/click-to-call', formData)
  if (response.status === 200) {
    // notificationSuccess('Call Saved')
    if (callback) {
      callback()
    }
  }
  return response.data
}
/*
export const sendClickToCallStart  = (data, callback) => async (_, getState) => {
  const reponse = await axios.post('/click-to-call', { data })
  if (reponse.status === 200) {
    // notificationSuccess('Call Saved')
    if (callback) {
      callback()
    }
  }

}
*/

export const setActivityId = (id) => (dispatch) => {
  dispatch({
    type: SET_ACTIVITY_ID,
    payload: id,
  })
}

export const sendClickToCallStart = (data) => async (dispatch, getState) => {
  const { userId, activePhone, phoneNumber, officeExt } = getState().auth.user

  if (!activePhone || !phoneNumber) {
    throw new Error(notificationDanger('Please enter phone number inside your profile!'))
  }

  // Prevent calling blacklisted numbers BEFORE starting RingCentral ring-out.
  // Fail-open: if we cannot verify status, allow the call to proceed.
  const digits = `${data?.call_number || ''}`.replace(/\D/g, '')
  if (digits) {
    const candidates = new Set([digits])
    // Handle common US formats where one side may include leading "1"
    if (digits.length === 11 && digits.startsWith('1')) candidates.add(digits.slice(1))
    if (digits.length === 10) candidates.add(`1${digits}`)

    let statusResp
    try {
      statusResp = await axios.post('/blacklisted-phones/status', { phones: [data.call_number] })
    } catch (e) {
      // Can't confirm -> allow call to proceed
      statusResp = null
    }

    const blacklisted = Array.isArray(statusResp?.data?.blacklisted) ? statusResp.data.blacklisted : []
    const isBlacklisted = Array.from(candidates).some((c) => blacklisted.includes(c))
    if (isBlacklisted) {
      notificationDanger('This phone number is blacklisted and cannot be called.')
      throw new Error('BLACKLISTED_PHONE')
    }
  }

  const userRcSession = await axios.get(`/users/userRcSession`)

  if (!userRcSession || !userRcSession.data || !Object.keys(userRcSession.data).length) {
    throw new Error(
      notificationDanger('RingCentral session not found, please login from you profile in order to make a calls!')
    )
  }

  const ringCentral = new RingCentralClient(userId)

  const rcResponse = await ringCentral.makeCall({
    caller: phoneNumber.replace(/\D/g, ''),
    extension: officeExt,
    recipient: data.call_number.replace(/\D/g, ''),
    user: {
      id: userId,
      accessToken: userRcSession.data.accessToken,
      expireTime: userRcSession.data.expireTime,
      expiresIn: userRcSession.data.expiresIn,
      refreshToken: userRcSession.data.refreshToken,
      refreshTokenExpireTime: userRcSession.data.refreshTokenExpireTime,
      refreshTokenExpiresIn: userRcSession.data.refreshTokenExpiresIn,
      rcLastUpdateTime: userRcSession.data.lastUpdateTime,
      useExtensionToMakeCalls: userRcSession.data.useExtensionToMakeCalls,
    },
  })

  const { error, errorMessage, callResponse, refreshedAccessToken } = rcResponse
  if (!error) {
    const response = await axios.post('/click-to-call', {
      data: {
        ...data,
        rc_id: callResponse.id,
        caller: phoneNumber.replace(/\D/g, ''),
      },
    })
    dispatch(setActivityId(response.data))
    if (Object.keys(refreshedAccessToken).length) {
      dispatch(updateAuthData(refreshedAccessToken, userId))
    }
    return true
  } else {
    notificationDanger(`Something went wrong!. Error message: ${errorMessage}`)
    throw new Error(errorMessage || 'RC_CALL_FAILED')
  }
  // if (response.status === 200) {
  // }
}

export const sendSharedNotes = (data, activityId) => async (_, getState) => {
  const state = getState()
  const division_id = state.auth.user.division_id
  const response = await axios.post('/activity/shared-notes', { ...data, division_id })

  if (activityId) {
    await axios.patch(`/activity/link-attachments/activity`, { activityId, sharedNoteId: response.data?.[0]?.id })
  }
}

export const getSharedNotes = (contactId, filter) => async (dispatch) => {
  dispatch(setLoading(true))
  const { data } = await axios.get(`/activity/shared-notes/${contactId}`, { params: { filter: { ...filter } } })
  dispatch({
    type: SET_TIMELINE_DATA,
    payload: data,
  })
  dispatch(setLoading(false))
}

export const getDataForRecentCalls = (options) => async (dispatch) => {
  const reponse = await axios.get('/click-to-call', { params: { ...options } })
  dispatch({
    type: SET_DATA_FOR_RECENT_CALLS_TABLE,
    payload: reponse.data,
  })
}

export const deleteSharedNote = (id, contactId) => async (dispatch) => {
  const response = await axios.delete(`/activity/shared-notes/${id}`)
  if (response.status === 200) {
    notificationSuccess('Successfully deleted shared note')
    dispatch(getHistoryData(contactId, 2))
  }
}

export const createSharedNote = (contactId, data, attachments) => async (dispatch, getState) => {
  if (!data?.note) {
    notificationDanger('Please enter note')
  } else {
    const state = getState()
    const user = state.auth.user
    const formData = new FormData()

    const note = {
      ...data,
      creationDate: now(),
      createdBy: user.userId,
      contactId,
      divisionId: user.division_id,
    }

    Object.entries(note).forEach(([key, value]) => {
      formData.append(key, value)
    })

    attachments.forEach((attachment) => {
      formData.append('attachments', attachment)
    })

    await axios.post(`/activity/shared-notes`, formData)
    dispatch(closeModal('shared_notes_modal'))
    dispatch(getHistoryData(contactId, 2))
  }
}

export const deleteActivity = (id, contactId) => async (dispatch) => {
  const response = await axios.delete(`/activity/activity/${id}`)
  if (response.status === 200) {
    notificationSuccess('Successfully deleted activity')
    dispatch(getHistoryData(contactId, 1))
  }
}

export const deleteComment = (id, contactId) => async (dispatch) => {
  const response = await axios.delete(`/comments/${id}`)
  if (response.status === 200) {
    notificationSuccess('Successfully deleted comment')
    dispatch(getHistoryData(contactId, 3))
  }
}

export const createComment = (contactId, data) => async (dispatch, getState) => {
  if (!data?.note) {
    notificationDanger('Please enter note')
  } else {
    const state = getState()
    const user = state.auth.user
    const comment = {
      ...data,
      creationDate: now(),
      createdBy: user.userId,
      contactId,
    }
    await axios.post(`/comments`, comment)
    dispatch(closeModal('comment_modal'))
    dispatch(getHistoryData(contactId, 3))
  }
}

export const saveData = (data) => async (dispatch) => {
  dispatch({
    type: SAVE_DATA_FOR_ACTIVITY,
    payload: data,
  })
}

export const setActivityInactive = (activityId) => async () => {
  await axios.patch(`/activity/set-inactive/${activityId}`)
}

export const setActivityInactiveFromModal = () => async (_, getState) => {
  const activityId = getState().ClickToCall.activityId
  if (activityId) {
    await axios.patch(`/activity/set-inactive/${activityId}`)
  }
}

export const updateActivity = (activityId, dataToUpdate) => async () => {
  await axios.patch(`/activity/${activityId}`, dataToUpdate)
}

// TODO - napraviti remove from redux function after creating task! please
